<script>
import _ from 'lodash'
import { mapState } from 'vuex'

import { CountryEnum } from '../store/modules/settings/types'
import SingleSelectedItemList from './diagnosis-lists/automation-demo-mode/SingleSelectedItemList.vue'

export default {
  components: {
    'single-selected-item-list': SingleSelectedItemList,
  },
  props: {
    appSettings: { type: Object, required: true },
    rumId: { type: Number, required: true },
    standardModeDiagnosisGroup: { type: Object, required: true },
    automationPreviewDiagnosisGroup: { type: Object, required: true },
    automationRulesPreview: { type: Object, default: null },
    selection: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
    healthData: { type: Object, required: true },
    rumPredictedLabels: { type: Array, default: null },
    suggestionJustifications: { type: Object, default: null },
  },
  emits: ['make-selection'],
  data() {
    return {
      CountryEnum,
    }
  },
  computed: {
    ...mapState({
      pmsiCountry: (state) => state.settings.pmsi.country,
    }),
    displayedAssociatedDiags() {
      return (this.standardModeDiagnosisGroup.associatedDiags ?? [])
        .filter((das) => !das.disabled)
        .map((das) => das.associatedDiagnosis)
    },
  },
  methods: {
    showRelatedDiags() {
      // FIXME - Sometimes automation mode diagnosis group is not set
      return this.pmsiCountry === CountryEnum.CH || _.get(this, 'standardModeDiagnosisGroup.currentDR') || _.get(this, 'automationPreviewDiagnosisGroup.currentDR') || _.get(this, 'automationRulesPreview.currentDR')
        || (this.standardModeDiagnosisGroup && this.standardModeDiagnosisGroup.currentDP && this.standardModeDiagnosisGroup.currentDP.reference[0] === 'Z')
        || (this.automationPreviewDiagnosisGroup && this.automationPreviewDiagnosisGroup.currentDP && this.automationPreviewDiagnosisGroup.currentDP.reference[0] === 'Z')
        || (this.automationRulesPreview && this.automationRulesPreview.currentDP && this.automationRulesPreview.currentDP.reference[0] === 'Z')
    },
  }
}
</script>

<template>
  <div class="card-container">
    <single-selected-item-list
      :app-settings="appSettings"
      :rum-id="rumId"
      :automation-preview-diagnosis-group="automationPreviewDiagnosisGroup"
      :standard-mode-diagnosis-group="standardModeDiagnosisGroup"
      :automation-rules-preview="automationRulesPreview"
      :selection="selection"
      :is-loading="isLoading"
      :health-data="healthData"
      :rum-predicted-labels="rumPredictedLabels"
      :suggestion-justifications="suggestionJustifications"
      type="DP"
      class="principal-diagnosis-group"
      @make-selection="(selection) => $emit('make-selection', selection)"
    />
    <single-selected-item-list
      v-if="showRelatedDiags()"
      :app-settings="appSettings"
      :rum-id="rumId"
      :automation-preview-diagnosis-group="automationPreviewDiagnosisGroup"
      :standard-mode-diagnosis-group="standardModeDiagnosisGroup"
      :automation-rules-preview="automationRulesPreview"
      :selection="selection"
      :is-loading="isLoading"
      :health-data="healthData"
      :rum-predicted-labels="rumPredictedLabels"
      :suggestion-justifications="suggestionJustifications"
      type="DR"
      class="related-diagnosis-group"
      @make-selection="(selection) => $emit('make-selection', selection)"
    />
    <div
      v-if="displayedAssociatedDiags.length"
      class="associated-diagnosis-group mb-2"
    >
      <h1 class="associated-title d-flex align-items-center">
        <span>DAS <small>- Établissement</small></span>
      </h1>
      <div class="row g-0">
        <div
          v-for="(das, idx) in displayedAssociatedDiags"
          :key="das.reference"
          class="col-6 mb-2"
          :class="{ 'ps-1': idx % 2, 'pe-1': (idx - 1) % 2 }"
        >
          <div class="card diagnosis-card small">
            <div class="card-body diagnosis-title">
              <h2 :title="das.description">
                {{ das.reference }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="automationRulesPreview?.associatedDiags?.length"
      class="associated-diagnosis-group"
    >
      <h1 class="associated-title d-flex align-items-center">
        <span>DAS <small>- Sancare</small></span>
      </h1>
      <div class="row g-0">
        <div
          v-for="(das, idx) in automationRulesPreview.associatedDiags"
          :key="das.reference"
          class="col-6 mb-2"
          :class="{ 'ps-1': idx % 2, 'pe-1': (idx - 1) % 2 }"
        >
          <div class="card diagnosis-card small">
            <div class="card-body diagnosis-title">
              <h2 :title="das.description">
                {{ das.reference }}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.associated-title {
  font-size: 1.5rem;
}

h2 {
  font-size: 1.1rem;
}
</style>
